import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Badge from 'base-ui/dist/Badge';
import Card from 'base-ui/dist/Card';
import Col from 'base-ui/dist/Col';
import get from 'base-ui/dist/underline/get';
import has from 'base-ui/dist/underline/has';
import Image from 'components/Image';
import CoursesLink from 'components/CoursesLink';
import IsOnline from './IsOnline';
import Rating from './Rating';
import Campaign from './Campaign';
import CampaignCountdown from './CampaignCountdown';
import BuyButton from './BuyButton';
import NaturalList from './NaturalList';
import messages from './messages';

// eslint-disable-next-line react/prefer-stateless-function
function CourseUnycos({ articleUrl, source, campaign, medium, categoriesName, item, instructorsName, style, buttonText }) {
  return (
    <Fragment>
      <article className="content-course-related">
        <Card>
          <CoursesLink
            toRoute={articleUrl}
            source={source}
            campaign={campaign}
            medium={medium}
            style={{ fontWeight: 'initial' }}
            courseName={item.name}
          >
            <div className="thumb">
              <Badge className="cat">
                <NaturalList list={categoriesName} />
              </Badge>
              {has(item, 'campaign.expired') && get(item, 'campaign.show_countdown') ? (
                <span className="badge countdown red-bg" style={style}>
                  <CampaignCountdown campaign={item.campaign} />
                </span>
              ) : null}
              <div className="thumb-wrap">
                <Image src={get(item, 'widget.image', item.image)} srcSet={item?.srcSet} alt={item.name} lazy className="thumb-bg" />
              </div>
            </div>
            <div className="course-caption">
              <span className="course-title">
                {get(item, 'widget.title', item.name)}
              </span>
              <div className="metas">
                <span className="meta">
                  <div>
                    <FormattedMessage {...messages.aCourseBy} />
                    {' '}
                    <CoursesLink
                      toRoute={articleUrl}
                      source={source}
                      campaign={campaign}
                      medium={medium}
                      courseName={item.name}
                    >
                      <NaturalList className="meta-url-link" list={instructorsName} />
                    </CoursesLink>
                  </div>
                </span>
              </div>
              <hr className="regent-grey-bg" />
              {item.subtitle || ' '}
              <div className="course-footer">
                <div className="row middle-xs">
                  <Col xs={6}>
                    <div className="metas">
                      <span className="meta grey-color">
                        <IsOnline type={item.type} />
                      </span>
                      <span className="meta grey-color">
                        <Rating likes={item.total} likeRate={item.likeRate} />
                      </span>
                    </div>
                  </Col>
                  <Col xs={6} className="end-xs" style={style}>
                    <Campaign
                      price={item.price}
                      campaign={item.campaign}
                      layout="unycos"
                    />
                  </Col>
                  <Col xs={12}>
                    <BuyButton
                      price={item.price}
                      campaignItem={item.campaign}
                      slug={item.slug}
                      source={source}
                      campaign={campaign}
                      medium={medium}
                      buttonText={buttonText}
                      courseName={item.name}
                    />
                  </Col>
                </div>
              </div>
            </div>
          </CoursesLink>
        </Card>
      </article>
      <hr className="transparent-bg" />
    </Fragment>
  );
}

CourseUnycos.propTypes = {
  campaign: PropTypes.string,
  articleUrl: PropTypes.any,
  source: PropTypes.string,
  medium: PropTypes.string,
  categoriesName: PropTypes.array,
  item: PropTypes.object,
  instructorsName: PropTypes.any,
  style: PropTypes.any,
  buttonText: PropTypes.string,
};

export default CourseUnycos;
